import axios, { AxiosError, AxiosRequestConfig } from "axios"
import {
  requestInterceptorErrorSecurityCredentials,
  requestInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
  responseInterceptorSuccessCredentials,
} from "interceptors"
import { IUploadXMLResponse } from "types"

const instance = axios.create({
  baseURL: process.env.REACT_APP_DOCUMENTS_API_SERVICE_DOMAIN,
})

instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

const formDataConfig: AxiosRequestConfig = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
}

export const wsUploadXMLManuallyService = async (file: any) => {
  const formData = new FormData()
  formData.append("file", file)
  try {
    const result = await instance.post("/uploadxml", formData, formDataConfig)
    const data = result.data as {
      claveAcceso: string
    }
    return data.claveAcceso
  } catch (error: any) {
    throw new Error((error as AxiosError)?.response?.data.message)
  }
}

export const wsUploadXMLMasiveService = async (files: File[]) => {
  const formData = new FormData()
  files.forEach((file) => {
    formData.append("file", file) // Cambiar 'files' a 'file'
  })

  try {
    const result = await instance.post("/upload/xml", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    const data: IUploadXMLResponse = result.data
    return data
  } catch (error: any) {
    throw new Error((error as AxiosError)?.response?.data.message)
  }
}
